<template lang="pug">
.ministry-links
  .level.is-mobile.has-text-grey
    .level-left
      .level-item(v-if="showLink('current_event_count')")
        b-icon(icon="calendar-blank" size="is-small")
        span {{ ministry.current_event_count }} upcoming {{ ministry.current_event_count === 1 ? 'event' : 'events' }}
      .level-item(v-if="showLink('email')")
        a(:href="`mailto:${ministry.email}`")
          b-icon(icon="email-outline" size="is-small")
          span {{ ministry.email }}
      .level-item(v-if="showLink('phone_number')")
        b-icon(icon="cellphone" size="is-small")
        span {{ ministry.phone_number }}
</template>

<script>
export default {
  name: 'ministry-links',
  computed: {
    ministry() {
      return this.value;
    },
  },
  methods: {
    showLink(key) {
      return this.links.includes(key) && this.ministry[key];
    },
  },
  props: {
    links: {
      type: Array,
      default() {
        return ['email', 'phone_number'];
      },
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.ministry-links {
  .link {
    display: flex;
    align-items: center;
  }
  a {
    color: $grey;
    &:hover {
      color: $grey;
      text-decoration: underline;
    }
  }
}
</style>
